import { isNil } from 'lodash-es';
import { StationColor, StationType } from '../../const';

export const calcWidth = (width: number | string, withoutChildren?: any[]) => {
  if (typeof width === 'string') return width;
  return withoutChildren?.length === 1
    ? width
    : (width - 8 * (withoutChildren ?? []).length - 1) / (withoutChildren ?? []).length;
};

export const calcMinWidth = (width: number | string) => {
  if (typeof width === 'string') return 160;
  return width === 500 ? 161 : 160;
};

export const style = (isShowBorder: boolean) => {
  return {
    border: !isShowBorder ? 'none' : '1px solid var(--mx-card-dark-bg-color)',
    background: !isShowBorder ? 'none' : 'rgba(74, 144, 226, 0.2)',
    padding: !isShowBorder ? '0px' : '8px',
  };
};

export const calcProcessColor = (rate: number | null) => {
  if (!rate) return 'transparent';
  if (rate < 75) {
    return '#16DD8E';
  }
  if (rate >= 75 && rate < 85) {
    return '#FFCB47';
  }
  if (rate >= 85 && rate < 95) {
    return '#FF9247';
  }
  if (rate >= 95) {
    return '#FF4D4F';
  }
};

export const noChildWrapperStyle = (level: number, width: number | string, withoutChildren?: any[], item?: any) => {
  const widthValue = typeof width === 'string' ? width : `${calcWidth(width, withoutChildren)}px`;
  return {
    background: StationColor[level],
    minWidth: `${calcMinWidth(width)}px`,
    width: widthValue,
    cursor: item?.type === StationType.DistributionStation ? 'pointer' : 'unset',
  };
};

export const hasChildEachLevel = (level: number, item?: any) => {
  return {
    background: StationColor[level],
    cursor: item?.type === StationType.DistributionStation ? 'pointer' : 'unset',
  };
};

export const calcPadding = (item?: any, noPBtoom?: boolean) => {
  const res = (item?.monitorItemList ?? []).some((x: any) => !isNil(x.loadRate));
  if (noPBtoom) {
    return res ? 8 : 0;
  }
  return res ? 0 : 8;
};
